import { useEntityList } from '@backstage/plugin-catalog-react';

import Tabs from '@mui/material/Tabs';

import { useDaaSTypeCounts } from '../../hooks';
import type { DaaSType } from '../../types';
import { DaaSTypeTab, useDaaSTypeTabStyles } from '../DaaSTypeTab';
import { DAAS_TYPE_TABS } from './typeTabs';

type DaaSTypeTabsProps = {
  selectedType: DaaSType;
  onChange: (type: DaaSType) => void;
};

export const DaaSTypeTabs = ({ selectedType, onChange }: DaaSTypeTabsProps) => {
  const { classes } = useDaaSTypeTabStyles();
  const { filters } = useEntityList();
  const { counts } = useDaaSTypeCounts(filters);

  return (
    <Tabs
      aria-label="DaaS entity types"
      value={selectedType}
      onChange={(_, type: DaaSType) => onChange(type)}
      variant="scrollable"
      allowScrollButtonsMobile
      className={classes.typeTabs}
    >
      {DAAS_TYPE_TABS.map(({ type }) => (
        <DaaSTypeTab key={type} value={type} count={counts?.[type]} />
      ))}
    </Tabs>
  );
};
